import { authStorage } from '~/lib/authStorage';
export const useOwnerStore = defineStore('ownerStore', {
  state: () => ({
    owner: null,
    reservations: [],
    facilityToEdit: null,
    teamMemberToEdit: null,
  }),
  actions: {
    setOwner(owner) {
      this.owner = owner;
    },
    setOwnerReservations(reservations) {
      this.reservations = reservations;
    },
    setFacilityToEdit(facility) {
      this.facilityToEdit = facility;
    },
    setTeamMemberToEdit(teamMember) {
      this.teamMemberToEdit = {
        ...teamMember,
        facilityIds: teamMember?.facilities?.map((facility) => facility.id)
      }
    },
    removeFacility(facilityId) {
      this.owner.facility = this.owner.facility.filter(
        facility => facility.id !== facilityId
      );
    },
    reset () {
      this.owner = null;
      this.reservations = [];
      this.facilityToEdit = null;
    }
  },
  getters: {
    getOwner: (state) => state.owner,
    getFacilityById: (state) => {
      return (id) => state.owner?.facility?.find((f) => f.id === id);
    },
    getOwnerFacilities: (state) => state.owner?.facility.filter((f) => f.status === 'ACTIVE'),
    getOwnerTeamMembers: (state) => {
      // TODO: Remove members with status "DELETED"
      const teamMembers = state.owner?.facility.flatMap((facility) => facility.teamMembers)
      return [...new Map(teamMembers?.map(member => [member.id, member]))?.values().filter((tm) => tm.status === 'ACTIVE')];
    },
    getOwnerLots: (state) => {
      // Create array of lots from all facilities then filter
      const allLots = state?.owner?.facility.flatMap((facility) => facility?.lots);
      return allLots?.filter((lot) => lot.status === 'ACTIVE');
    },
    limits: () => {
      return globalConfig()?.ownerPlan?.limits
    },
    facilitiesAvailable: (state) => {
      const maxFacilitiesCount = globalConfig()?.ownerPlan?.limits?.max_facility_count;
      return maxFacilitiesCount - state?.getOwnerFacilities?.length;
    },
    lotsAvailable: (state) => {
      const maxLotsCount = globalConfig()?.ownerPlan?.limits?.max_lots_count;
      return maxLotsCount - state?.getOwnerLots?.length;
    },
    spotsUsed: (state) => {
      const approvedLots = state.getOwnerLots?.filter((lot) => lot.isApproved);
      return approvedLots?.reduce((total, lot) => total + (lot?.spots || 0), 0);
    },
    spotsAvailable: (state) => {
      return globalConfig()?.ownerPlan?.limits?.max_spots_count - state?.spotsUsed;
    },
    ownerReservations: (state) => {
      return [...state?.reservations?.items].sort((a, b) =>
        new Date(b.checkinDatetime) - new Date(a.checkinDatetime)
      );
    },
    upcomingReservations: (state) => {
      const now = new Date();

      return state.reservations?.items?.filter(reservation => {
        const checkoutDatetime = new Date(reservation.checkoutDatetime);
        return (checkoutDatetime > now) && (reservation.status === 'CONFIRMED');
      });
    },
    pastReservations: (state) => {
      const now = new Date();

      return state.reservations?.items?.filter(reservation => {
        const checkoutDatetime = new Date(reservation.checkoutDatetime);
        return (reservation.status === 'CONFIRMED') && (checkoutDatetime < now);
      });
    },
    cancelledReservations: (state) => {
      return state.reservations?.items?.filter((reservation) => reservation.status === 'CANCELLED');
    },
    cancellationRate: (state) => {
      const totalReservations = state.reservations?.items?.length;
      const cancelledReservations = state.reservations?.items?.filter((reservation) => reservation.status === 'CANCELLED')?.length;
      return `${parseFloat((cancelledReservations / totalReservations) * 100).toFixed(2)}%`;
    },
    typesOfReservations: (state) => {
      return {
        hourly: state.reservations?.items?.filter((reservation) => reservation.type === 'HOURLY')?.length,
        daily: state.reservations?.items?.filter((reservation) => reservation.type === 'DAILY')?.length,
        overnight: state.reservations?.items?.filter((reservation) => reservation.type === 'OVERNIGHT')?.length,
        multiDay: state.reservations?.items?.filter((reservation) => reservation.type === 'HOURLY' || reservation.type === 'OVERNIGHT')?.length,
      }
    }
  },
  persist: {
    storage: authStorage
  },
});
